


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './App';
// import reportWebVitals from './reportWebVitals';
// ✅ PATCH: Remove invalid CSS selectors on legacy browsers
const isLegacyBrowser = !CSS.supports?.('selector(:not(title, meta))');

if (typeof window !== 'undefined' && isLegacyBrowser) {
  try {
    Array.from(document.styleSheets).forEach(sheet => {
      try {
        Array.from(sheet.cssRules).forEach((rule, index) => {
          if (
            rule.selectorText &&
            rule.selectorText.includes(':not(title, meta)')
          ) {
            sheet.deleteRule(index);
            console.warn('⚠️ Removed invalid CSS selector:', rule.selectorText);
          }
        });
      } catch (err) {
        // Skip CORS-protected or inaccessible sheets
      }
    });
  } catch (e) {
    console.error("Legacy CSS cleanup failed:", e);
  }
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);